var mapThumbnails = function mapThumbnails(thumbnail) {
  return {
    previewThumbnails: {
      enabled: true,
      src: "".concat(thumbnail.path)
    }
  };
};

export default mapThumbnails;